const Testomonial_Api = [
  {
    id: 1,
    image: "./image/Testimonial_image/Rana.jpg",
    name: "Mahmudul Islam Rana",
    designation: "General Secretary",
    company: "Bangladesh Taekwondo Federation",
    address: "National Sports Council, Paltan, Dhaka",
    desc: "As a technical lead, Nasif revolutionized our sports federation's digital presence. His expertise in technology and strategic thinking enhanced our operations and engagement with athletes and fans. His contributions were invaluable to our success.",
  },
  {
    id: 2,
    image: "./image/Testimonial_image/Anica.jpeg",
    name: "Gazi Anica Aslam",
    designation: "Program Officer",
    company: "Youth Against Hunger Bangladesh",
    address: "An International Youth Organization",
    desc: "Nasif's leadership in our youth organization was exceptional. His ability to motivate and guide young members led to numerous successful events and initiatives. His dedication and vision have left a lasting impact on our community.",
  },
  {
    id: 3,
    image: "./image/Testimonial_image/Setu.jpg",
    name: "Alim Uddin",
    designation: "District Control Commissioner (DCC)",
    company: "Bangladesh Bureau of Statistics (BBS)",
    address: "Agargaon, Mirpur, Dhaka",
    desc: "Nasif's work with the Bureau of Statistics was outstanding. His technical skills and attention to detail greatly improved our data management and analysis processes. His contributions were critical to the success of our government projects.",
  },
];

export default Testomonial_Api;
